import { render, staticRenderFns } from "./PersonSpecificationHelper.vue?vue&type=template&id=d32f288c&scoped=true&"
import script from "./PersonSpecificationHelper.vue?vue&type=script&lang=js&"
export * from "./PersonSpecificationHelper.vue?vue&type=script&lang=js&"
import style0 from "./PersonSpecificationHelper.vue?vue&type=style&index=0&id=d32f288c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32f288c",
  null
  
)

export default component.exports